import { useParams } from 'react-router'
import { skipToken, useQuery } from '@tanstack/react-query'
import { useApi } from 'api'
import { queryKeys } from 'api/queryKeys'
import { normalizeApiError } from 'shared/helpers/notificationHandlers'

function useInvoice(idOverride?: string) {
  const api = useApi()
  const { id: paramId } = useParams<{ id: string }>()
  const id = idOverride ?? paramId
  const isValidId = id !== undefined && id !== '' && !isNaN(Number(id))

  const { data: invoice, isPending, isError, error } = useQuery({
    queryKey: queryKeys.invoice.detail(id),
    queryFn: isValidId
      ? async () => (await api.getInvoice({ id: Number(id) })).data
      : skipToken,
  })

  const isNotFound = normalizeApiError(error)?.status === 404

  return { invoice, isPending: isValidId && isPending, isError: isError && !isNotFound }
}

export default useInvoice
